import _ from 'lodash'
import { message } from 'antd';

import { call, put, all, select, takeLatest, takeEvery } from 'redux-saga/effects'
import { getAppointments, addUpdateAppointmentDB, addUpdateAppointmentEventDB, fetchResourceAvailabilityRosterAPI, cancelAppointmentAPI, getReferralDocumentsAPI, fetchAppointmentsByMipAPI } from '../../../services/appointments-service';
import { fetchModalityTypes } from '../../../appRedux/sagas/common/modalityTypesSaga';

import {
    FETCH_APPOINTMENTS,
    FETCH_APPOINTMENTS_START,
    FETCH_APPOINTMENTS_SUCCESS,
    FETCH_APPOINTMENTS_ERROR,
    ADD_UPDATE_APPOINTMENT,
    ADD_UPDATE_APPOINTMENT_START,
    ADD_UPDATE_APPOINTMENT_SUCCESS,
    ADD_UPDATE_APPOINTMENT_ERROR,
    ADD_UPDATE_APPOINTMENT_EVENT,
    ADD_UPDATE_APPOINTMENT_EVENT_START,
    ADD_UPDATE_APPOINTMENT_EVENT_SUCCESS,
    ADD_UPDATE_APPOINTMENT_EVENT_ERROR,
    SET_SELECTED_APPOINTMENT,
    SET_SELECTED_APPOINTMENT_START,
    SET_SELECTED_APPOINTMENT_SUCCESS,
    SET_SELECTED_APPOINTMENT_ERROR,
    RESET_SELECTED_APPOINTMENT,
    FETCH_RESOURCE_AVAILABILITY_ROSTER,
    FETCH_RESOURCE_AVAILABILITY_ROSTER_START,
    FETCH_RESOURCE_AVAILABILITY_ERROR,
    FETCH_RESOURCE_AVAILABILITY_SUCCESS,
    DELETE_APPOINTMENT_EVENT_START,
    DELETE_APPOINTMENT_EVENT_SUCCESS,
    DELETE_APPOINTMENT_EVENT_ERROR,
    DELETE_APPOINTMENT_EVENT,
    CANCEL_APPOINTMENT,
    CANCEL_APPOINTMENT_SUCCESS,
    LOAD_APPOINMENT_CALENDAR,
    LOAD_APPOINMENT_CALENDAR_START,
    LOAD_APPOINMENT_CALENDAR_SUCCESS,
    LOAD_APPOINMENT_CALENDAR_ERROR,
    VIEW_REFERENCE_DOCS_SUCCESS,
    VIEW_REFERENCE_DOCS_ERROR,
    VIEW_REFERENCE_DOCS,
    FETCH_APPOINTMENTS_BY_MIP,
    FETCH_APPOINTMENTS_BY_MIP_START,
    FETCH_APPOINTMENTS_BY_MIP_SUCCESS,
    SET_APPOINTMENTS_PAGINATION,
    UPLOAD_APPOINTMENT_DOCUMENT,
    FETCH_APPOINTMENTS_BY_MIP_ERROR,
    UPLOAD_APPOINTMENT_DOCUMENT_SUCCESS,
    UPLOAD_APPOINTMENT_DOCUMENT_ERROR
} from "../../actions/receptionist/appointmentsAction";
import { EVENT_TYPES } from '../../../constants/constants';
import { cancelAppointmentEventAPI } from '../../../services/appointments-service';
import { getPracticeMachines } from '../rosterSaga';
import { uploadAppointmentDocumentAPI } from '../../../services/appointments-patient-visits-service';
import { addAppointmentNote } from '../../../services/appointments-patient-visits-service'; 

const getModalityTypes = (state) => {
    let modalityObject = {};
    state.modalityTypes.modalityTypes.forEach(modality => {
        modalityObject[modality.modalityId] = modality.name;
    })
    return modalityObject;
};

const getStateAppointments = (state) => state.receptionist.appointments.appointments;

function* loadAppiontmentCalendar({ payload }) {
    try {
        yield put({ type: LOAD_APPOINMENT_CALENDAR_START })
        yield all([
            yield call(getPracticeMachines, { practiceId: payload.practiceId }),
            yield call(fetchResourceAvailablityRoster, { payload }),
            yield call(fetchAppointments, { payload })
        ])
        yield put({ type: LOAD_APPOINMENT_CALENDAR_SUCCESS })
    } catch (error) {
        yield put({ type: LOAD_APPOINMENT_CALENDAR_ERROR, error })
        message.error('Failed to load appointment calendar!');
    }
}

function* fetchResourceAvailablityRoster({ payload }) {
    try {
        yield put({ type: FETCH_RESOURCE_AVAILABILITY_ROSTER_START })
        const response = yield call(fetchResourceAvailabilityRosterAPI, payload);
        if (response.success) {
            const resourcesAvailabilityRoster = response.data.map(event => {
                return {
                    ...event,
                    timeslotId: event.timeslotId,
                    resourceId: event.machineId,
                    title: event.resourceName,
                    start: new Date(event.startTime),
                    end: new Date(event.endTime),
                    desc: event.description,
                    isAllDay: event.allDay,
                    eventType: EVENT_TYPES.ROSTER
                };
            });
            yield put({ type: FETCH_RESOURCE_AVAILABILITY_SUCCESS, roster: resourcesAvailabilityRoster })
        } else {
            yield put({ type: FETCH_RESOURCE_AVAILABILITY_ERROR, error: response.error })
            message.error('Failed to fetch resource availability roster!');
        }
    } catch (error) {
        yield put({ type: FETCH_RESOURCE_AVAILABILITY_ERROR, error })
        message.error('Failed to fetch resource availability roster!');
    }
}

function* fetchAppointments({ payload }) {
    try {
        yield put({ type: FETCH_APPOINTMENTS_START })
        yield call(fetchModalityTypes);
        const response = yield call(getAppointments, payload);
        if (response.success) {
            const modalityTypes = yield select(getModalityTypes);
            if (Object.keys(modalityTypes).length > 0) {
                let calendarEvents = [];
                response.appointments.forEach(appointment => {
                    appointment.events.forEach(event => {
                        let calendarEvent = {
                            ...event,
                            appointmentId: appointment.appointmentId,
                            resourceId: event.machineId,
                            // title: modalityTypes[event.modalityId] || 'NA',
                            title: ``,
                            modalityName: modalityTypes[event.modalityId] || 'NA',
                            start: new Date(event.start),
                            end: new Date(event.end),
                            desc: "",
                            isAllDay: event.allDay,
                            eventType: EVENT_TYPES.APPOINTMENT,
                            patientName: `${appointment.firstname} ${appointment.lastname}`,
                            patientGender: appointment.gender
                        };
                        calendarEvents.push(calendarEvent);
                    });
                });
                yield put({
                    type: FETCH_APPOINTMENTS_SUCCESS,
                    payload: {
                        appointments: response.appointments,
                        calendarEvents: calendarEvents
                    }
                })
            } else {
                message.error('Modality types not found!');
            }
        } else {
            yield put({ type: FETCH_APPOINTMENTS_ERROR, error: response.error })
            message.error('Failed to fetch appointments!');
        }
    } catch (error) {
        yield put({ type: FETCH_APPOINTMENTS_ERROR, error })
        message.error('Failed to fetch appointments!');
    }
}

const handleSubmitNote = async ({appointmentId, note}) => {
    const payload = {
      appointmentId: appointmentId,
      notes: [note],
    };

    const result = await addAppointmentNote(payload);

    if (!result.success) {
      message.error("Something went wrong in saving appointment notes");
    }
  };


function* addUpdateAppointment({ appointment }) {
    try {
        const modalityTypes = yield select(getModalityTypes);
        if (Object.keys(modalityTypes).length === 0) {
            message.error('Modality types not found!');
            return;
        }
        yield put({ type: ADD_UPDATE_APPOINTMENT_START })
        const response = yield call(addUpdateAppointmentDB, appointment);
        
        if (response.success) {
            const event = response.appointment.events[0];
            let calendarEvent = {
                ...event,
                appointmentId: response.appointment.appointmentId,
                resourceId: event.machineId,
                // title: modalityTypes[event.modalityId] || 'NA',
                title: ``,
                modalityName: modalityTypes[event.modalityId] || 'NA',
                start: new Date(event.start),
                end: new Date(event.end),
                desc: "",
                isAllDay: event.allDay,
                eventType: EVENT_TYPES.APPOINTMENT,
                patientName: `${response.appointment.firstname} ${response.appointment.lastname}`,
                patientGender: response.appointment.gender
            };
            yield put({
                type: ADD_UPDATE_APPOINTMENT_SUCCESS,
                payload: {
                    appointment: response.appointment,
                    calendarEvent,
                }
            })
            if (response.appointment.status === "Created") {
                yield put({ type: RESET_SELECTED_APPOINTMENT })
            } else {
                yield put({
                    type: SET_SELECTED_APPOINTMENT,
                    appointmentId: response.appointment.appointmentId,
                })
            }
            if (appointment.appointmentId === 0) {
                message.success('Reserved slot successfully.');
            } else {
                message.success('Appointment saved successfully.');
            }

            appointment.resolve({ success: true, resp: response });
        } else {
            yield put({ type: ADD_UPDATE_APPOINTMENT_ERROR, error: response.error })
            if (appointment.appointmentId === 0) {
                message.error(response?.error?.response?.data || 'Failed to reserve slot!!');
            } else {
                message.error(response?.error?.response?.data || 'Failed to save appointment!');
            }
            appointment.resolve({ success: false });
        }
    } catch (error) {
        yield put({ type: ADD_UPDATE_APPOINTMENT_ERROR, error })
        message.error(error);
    }
}

function* addUpdateAppointmentEvent({ event }) {
    try {
        const modalityTypes = yield select(getModalityTypes);
        if (Object.keys(modalityTypes).length === 0) {
            message.error('Modality types not found!');
            return;
        }
        yield put({ type: ADD_UPDATE_APPOINTMENT_EVENT_START })
        const response = yield call(addUpdateAppointmentEventDB, event);
        if (response.success) {
            const updatedEvent = {
                ...response.event,
                status: event.status || response.event.status,
            };
            let calendarEvent = {
                ...event,
                ...updatedEvent,
                resourceId: updatedEvent.machineId,
                // title: modalityTypes[response.event.modalityId] || 'NA',
                title: ``,
                modalityName: modalityTypes[event.modalityId] || 'NA',
                start: new Date(updatedEvent.start),
                end: new Date(updatedEvent.end),
                desc: "",
                isAllDay: response.event.allDay,
                eventType: EVENT_TYPES.APPOINTMENT,
                patientName: event.patientName || ``,
                patientGender: event.patientGender || ``
            };
            yield put({
                type: ADD_UPDATE_APPOINTMENT_EVENT_SUCCESS,
                payload: {
                    event: updatedEvent,
                    calendarEvent: calendarEvent
                }
            })
            message.success('Appointment event updated successfully!');
        } else {
            yield put({ type: ADD_UPDATE_APPOINTMENT_EVENT_ERROR, error: response.error })
            message.error('Failed to update appointment event!');
        }
    } catch (error) {
        yield put({ type: ADD_UPDATE_APPOINTMENT_EVENT_ERROR, error })
        message.error('Failed to update appointment event!');
    }
}

function* deleteAppointmentEvent({ payload }) {
    try {
        yield put({ type: DELETE_APPOINTMENT_EVENT_START })
        const response = yield call(cancelAppointmentEventAPI, payload);
        if (response.success) {
            yield put({
                type: DELETE_APPOINTMENT_EVENT_SUCCESS,
                payload
            })
            message.success('Appointment event cancelled successfully!');
        } else {
            yield put({ type: DELETE_APPOINTMENT_EVENT_ERROR, error: response.error })
            message.error('Failed to cancel appointment event!');
        }
    } catch (error) {
        console.log('error', error);
        yield put({ type: DELETE_APPOINTMENT_EVENT_ERROR, error })
        message.error('Failed to cancel appointment event!');
    }
}

function* setAppointment({ appointmentId }) {
    try {
        yield put({ type: SET_SELECTED_APPOINTMENT_START })
        const modalityTypes = yield select(getModalityTypes);
        if (Object.keys(modalityTypes).length === 0) {
            message.error('Modality types not found!');
            return;
        }
        const appointments = yield select(getStateAppointments);
        const appointment = appointments.find(
            (item) => item.appointmentId == appointmentId
        );
        if (appointment) {
            const events = appointment.events.map(event => {
                return {
                    ...event,
                    resourceId: event.machineId,
                    // title: modalityTypes[event.modalityId] || 'NA',
                    title: ``,
                    modalityName: modalityTypes[event.modalityId] || 'NA',
                    key: `${appointment.mipId}-${event.machineId}-${appointment.appointmentId}-${event.eventId}`
                }
            });
            yield put({
                type: SET_SELECTED_APPOINTMENT_SUCCESS,
                appointment: {
                    ...appointment,
                    events
                }
            })
        } else {
            yield put({ type: SET_SELECTED_APPOINTMENT_SUCCESS, appointment: null })
            message.error('Appointment event not found!');
        }
    } catch (error) {
        yield put({ type: SET_SELECTED_APPOINTMENT_ERROR, error })
        message.error('Failed to select appointment event!');
    }
}

function* cancelAppointment({ payload }) {
    const response = yield call(cancelAppointmentAPI, payload);
    if (response.success) {
        yield put({ type: CANCEL_APPOINTMENT_SUCCESS, appointmentId: payload });
        message.success('Cancelled event successfully.');

    } else {
        message.error('Failed to cancel event!');
    }
}

function* fetchReferralDocuments({ payload }) {
    try {

        const response = yield call(getReferralDocumentsAPI, payload.appointmentId);

        if (response.success) {
            yield put({ type: VIEW_REFERENCE_DOCS_SUCCESS, referralDocuments: _.cloneDeep(response.data) })


        } else {
            yield put({ type: VIEW_REFERENCE_DOCS_ERROR, error: response.error })
        }

    }
    catch (error) {
        yield put({ type: VIEW_REFERENCE_DOCS_ERROR, error: error })

    }
}

function* uploadAppointmentDocument({ payload }) {

    try {
        // yield put({ type: UPLO })
        const response = yield call(uploadAppointmentDocumentAPI, payload.document);
        if (response.success) {
            yield put({ type: UPLOAD_APPOINTMENT_DOCUMENT_SUCCESS, appointment: response.data })
            message.success('Uploaded appointment document successfully!');

        } else {
            yield put({ type: UPLOAD_APPOINTMENT_DOCUMENT_ERROR, error: response.error })
            message.error('Failed to upload appointment document!');
        }

    } catch (error) {
        message.error('Failed to upload appointment document!');
        yield put({ type: UPLOAD_APPOINTMENT_DOCUMENT_ERROR, error: error })
    }
}

function* fetchAppointmentsByMip({ payload }) {
    try {
        yield put({ type: FETCH_APPOINTMENTS_BY_MIP_START })
        const response = yield call(fetchAppointmentsByMipAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }

            yield put({ type: SET_APPOINTMENTS_PAGINATION, pagination });
            yield put({ type: FETCH_APPOINTMENTS_BY_MIP_SUCCESS, payload: { appointments: _.cloneDeep(response.data.appointmentList), sortConditions: payload.sortConditions } })

        } else {
            yield put({ type: FETCH_APPOINTMENTS_BY_MIP_ERROR, error: response.error })
            if (response.error) {
                message.error(response.error);
            } else {
                message.error('Failed to fetch appointments!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_APPOINTMENTS_BY_MIP_ERROR, error })
        message.error('Failed to fetch appointments!');
    }
}

function* appointmentsWatcher() {
    yield takeLatest(LOAD_APPOINMENT_CALENDAR, loadAppiontmentCalendar)
    yield takeLatest(FETCH_APPOINTMENTS, fetchAppointments)
    yield takeEvery(ADD_UPDATE_APPOINTMENT, addUpdateAppointment)
    yield takeLatest(ADD_UPDATE_APPOINTMENT_EVENT, addUpdateAppointmentEvent)
    yield takeLatest(DELETE_APPOINTMENT_EVENT, deleteAppointmentEvent)
    yield takeLatest(SET_SELECTED_APPOINTMENT, setAppointment)
    yield takeLatest(UPLOAD_APPOINTMENT_DOCUMENT, uploadAppointmentDocument)
    yield takeLatest(FETCH_RESOURCE_AVAILABILITY_ROSTER, fetchResourceAvailablityRoster)
    yield takeLatest(CANCEL_APPOINTMENT, cancelAppointment)
    yield takeLatest(VIEW_REFERENCE_DOCS, fetchReferralDocuments)
    yield takeLatest(FETCH_APPOINTMENTS_BY_MIP, fetchAppointmentsByMip)
}

export default function* rootSaga() {
    yield all([
        appointmentsWatcher(),
    ]);
}